import React, { useState } from "react";
import { Modal } from "newui/components/ui/Modal";
import { InputWithLabel } from "newui/components/ui/InputWithLabel";
import { RecoveryCodesStep } from "./RecoveryCodesStep";
import { useRegenerateRecoveryCodes } from "../../hooks/useRegenerateRecoveryCodes";

export interface RegenerateCodesModalProps {
	isOpen: boolean;
	onClose: () => void;
}

export const RegenerateCodesModal = ({ isOpen, onClose }: RegenerateCodesModalProps) => {
	const [password, setPassword] = useState("");
	const [newCodes, setNewCodes] = useState<string[] | null>(null);
	const regenerate = useRegenerateRecoveryCodes();

	const handleClose = () => {
		setPassword("");
		setNewCodes(null);
		regenerate.reset();
		onClose();
	};

	const handleConfirm = () => {
		regenerate.mutate(
			{ password },
			{
				onSuccess: (resource) => {
					setNewCodes(resource.recovery_codes);
				},
			}
		);
	};

	if (newCodes) {
		return (
			<Modal
				isOpen={isOpen}
				onClose={handleClose}
				title="New recovery codes"
				iconType="download"
				closeOnEsc
			>
				<RecoveryCodesStep codes={newCodes} onDone={handleClose} />
			</Modal>
		);
	}

	return (
		<Modal
			isOpen={isOpen}
			onClose={handleClose}
			title="Regenerate recovery codes"
			description="Your existing recovery codes will stop working. Confirm your password to continue."
			iconType="warning"
			modalType="alert"
			closeOnEsc
			primaryButton={{
				text: "Regenerate",
				btntype: "danger",
				disabled: !password,
				isLoading: regenerate.isPending,
				onClick: handleConfirm,
			}}
			secondaryButton={{
				text: "Cancel",
				onClick: handleClose,
			}}
		>
			<InputWithLabel
				label="Password"
				type="password"
				icon
				value={password}
				onChange={(e) => setPassword(e.target.value)}
				errorText={regenerate.error?.message}
				testId="regenerate-codes-password-input"
				required
			/>
		</Modal>
	);
};
